import { isEmpty } from 'lodash';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export interface BaseStore<T> {
  data: T;
  setData: (data: T) => void;
  changeData: (newData: Partial<T>) => void;
  updateData: (data: Partial<T>) => void;
  clear: () => void;
}
export function createPersistentStore<T>(name: string, intialData?: T) {
  return create<BaseStore<T>>()(
    persist(
      (set, get, persist) => ({
        data: (get()?.data || intialData) ?? ({} as T),
        setData: (data: T) => {
          return set({
            data: !isEmpty(persist.getState().data) ? persist.getState().data : data,
          });
        },
        changeData: (newData: Partial<T>) => {
          const currentData = get().data;
          set({ data: { ...currentData!, ...newData } });
        },
        updateData: (data: Partial<T>) => {
          const currentData = get().data;
          set({ data: { ...currentData!, ...data } });
        },
        clear: () => {
          persist.persist.clearStorage();
          set({ data: {} as T });
        },
      }),
      {
        name,
        storage: createJSONStorage(() => localStorage),
      }
    )
  );
}
